import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { fetchPayments } from 'State/Payments/PaymentActions';
import { fetchProfileInfo } from 'State/User';
import BillingHistoryList from 'Features/BillingHistory/BillingHistoryList';
import ActiveUserPlan from 'Features/MyPlan/ActiveUserPlan';
import { useStore } from 'Hooks/useStore';

export function BillingHistoryContainerComponent(props) {
  const {
    payments: { isSuccess, hasPayments, orders, activeBillInfo, nextBillInfo },
    fetchPayments,
  } = props;

  const {
    routes,
    defaultConfig: { entitlementId },
  } = useStore('appConfig');

  useEffect(() => {
    fetchProfileInfo();
    trackEvent(TRACKING_ENUMS.EVENT_BILLING_HISTORY_SELECTED);
  }, []);

  useEffect(() => {
    if (!isSuccess) fetchPayments(entitlementId);
  }, [fetchPayments, entitlementId, isSuccess]);

  return (
    <CenterFrameLayout
      title="My Billing History"
      showLoader={!isSuccess}
      goBack="Back to My Account"
      backUrl={routes.myAccount}
    >
      {(activeBillInfo || nextBillInfo) && (
        <ActiveUserPlan activeBillInfo={activeBillInfo} nextBillInfo={nextBillInfo} />
      )}
      {hasPayments ? (
        <BillingHistoryList orders={orders} />
      ) : (
        <div className="noBilling">Billing history is not available.</div>
      )}
    </CenterFrameLayout>
  );
}

export const BillingHistoryContainer = connect(({ payments }) => ({ payments }), { fetchPayments })(
  React.memo(BillingHistoryContainerComponent)
);
